import type { CncMachine } from '../../../shared/beachBumzMachines';
import type { CrewAccess, CrewJob, TeamMember } from '../../../shared/beachBumzTeam';
export type TeamResponse={machines?:CncMachine[];machineVersion?:string;jobs?:CrewJob[];job?:CrewJob;access?:CrewAccess;team?:TeamMember[];teamVersion?:string;truncated?:boolean;file?:Blob};
export type TeamApi=(body?:Record<string,unknown>,query?:Record<string,string>)=>Promise<TeamResponse>;
export function createTeamRequest(getToken:()=>Promise<string|null>):TeamApi {
  return async (body,query) => {
    const token=await getToken();
    if(!token)throw new Error('Please sign in again.');
    const params=new URLSearchParams(query||{});
    const response=await fetch(`/api/beach-bumz-team${params.size?'?'+params:''}`,{method:body?'PATCH':'GET',headers:{Authorization:`Bearer ${token}`,...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
    if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(error.error||'Crew workspace request failed.');}
    if(query?.fileId)return {file:await response.blob()};
    return response.json();
  };
}
export function saveCrewFile(blob:Blob,name:string){const url=URL.createObjectURL(blob);const a=document.createElement('a');a.href=url;a.download=name;document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);}
